import RepositoryFactory from "@/marcom/Apicall/RepositoryFactory";
const template = RepositoryFactory.template;

export default {
  getAll({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await template.getAll(payload);
        // commit("GET_EMAIL_CONFIG", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
